import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import HandOffLink from '../../../utils/urls/HandOffLink';

import typography from '../../../styling/mixins/typography';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1.5rem 0 1rem;
  @media (${DESKTOP_START_QUERY}) {
    margin: 2rem 0 1.5rem;
  }
`;

const Title = styled.p`
  ${typography.BasisFont};
  flex: 3;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 20px;
  }
`;

const linkStyles = css`
  ${typography.linkStyles} margin-bottom: 0px;
`;

export default class Heading extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    link: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
  };

  render() {
    const { className, link, title } = this.props;

    const Link = styled(HandOffLink)`
      ${linkStyles};
    `;

    return (
      <Container className={className}>
        <Title>{title}</Title>
        {link && (
          <Link href={link.href} identifier={link.text ? link.text : 'Browse'}>
            {link.text ? link.text : 'Browse'}
          </Link>
        )}
      </Container>
    );
  }
}
